export const FETCH_IWO_STATUS_REQUEST = "FETCH_IWO_STATUS_REQUEST";
export const FETCH_IWO_STATUS_SUCCESS = "FETCH_IWO_STATUS_SUCCESS";
export const FETCH_IWO_STATUS_FAILURE = "FETCH_IWO_STATUS_FAILURE";

export const UPDATE_IWO_STATUS_REQUEST = "UPDATE_IWO_STATUS_REQUEST";
export const UPDATE_IWO_STATUS_SUCCESS = "UPDATE_IWO_STATUS_SUCCESS";
export const UPDATE_IWO_STATUS_FAILURE = "UPDATE_IWO_STATUS_FAILURE";
